import { Component, OnInit } from '@angular/core'
import { format } from 'date-fns'
import { CaDialogComponent } from '../ca-dialog.base'

@Component({
    selector: 'ca-date-select-dialog',
    templateUrl: './date-select-dialog.html',
    standalone: false
})
export class DateSelectDialogComponent extends CaDialogComponent<{
    buttonLabel: string;
    dates: string[];
    message: string;
    title: string;
}, string> implements OnInit {

    buttonLabel: string
    dates: string[]
    message: string
    title: string
    selectedDate: string

    constructor() {
        super()
    }

    ngOnInit() {
        this.selectedDate = this.dates[0]
    }

    formatDate(date: string): string {
        return format(new Date(date), 'dd. MM. y')
    }

    selectDate(): void {
        super.result = this.selectedDate
        super.close()
    }

    closeDialog(): void {
        super.result = null
        super.close()
    }
}